var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddHospital(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10356_492)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0013 2.98031C4.68759 2.98031 2.0013 5.6666 2.0013 8.98031C2.0013 12.294 4.68759 14.9803 8.0013 14.9803C11.315 14.9803 14.0013 12.294 14.0013 8.98031C14.0013 5.6666 11.315 2.98031 8.0013 2.98031ZM0.667969 8.98031C0.667969 4.93022 3.95121 1.64697 8.0013 1.64697C12.0514 1.64697 15.3346 4.93022 15.3346 8.98031C15.3346 13.0304 12.0514 16.3136 8.0013 16.3136C3.95121 16.3136 0.667969 13.0304 0.667969 8.98031ZM8.0013 5.64697C8.36949 5.64697 8.66797 5.94545 8.66797 6.31364V8.31364H10.668C11.0362 8.31364 11.3346 8.61212 11.3346 8.98031C11.3346 9.3485 11.0362 9.64697 10.668 9.64697H8.66797V11.647C8.66797 12.0152 8.36949 12.3136 8.0013 12.3136C7.63311 12.3136 7.33463 12.0152 7.33463 11.647V9.64697H5.33464C4.96645 9.64697 4.66797 9.3485 4.66797 8.98031C4.66797 8.61212 4.96645 8.31364 5.33464 8.31364H7.33463V6.31364C7.33463 5.94545 7.63311 5.64697 8.0013 5.64697Z",
    fill: "#017C57"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10356_492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.980469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddHospital);
export default __webpack_public_path__ + "static/media/addHospital.fc49210548839b8ba5501a3d26beb0d9.svg";
export { ForwardRef as ReactComponent };